export const LOADER_STATUS = "boilderplate/GSTR2X/FILE/LOADER_STATUS";
export const FILE_DATA = "boilderplate/GSTR2X/FILE/FILE_DATA";
export const SAVE_FILE_DATA = "boilderplate/GSTR2X/FILE/SAVE_FILE_DATA";
